import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';



import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';


import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import TableComponent from '../../components/Desenganche/Filtrado';
import TablePComponent from '../../components/Desenganche/Filtrado2';
import FormularComponen from '../../components/Desenganche/Formulario';
import { URL_EMPLOYEE } from '../../constans/servidor';
import { set } from 'immutable';



const BuscadorComponen = props => {
  const { Terminales } = props
  const [data, setData] = useState();
  const [objetos, setObjetos] = useState();
  const [datos, setDatos] = useState();
  const [loadingData, setLoadingData] = useState(false);
  const [placa, setPlaca] = useState();
  const [park, setPark] = useState('');
  const [placas, setPlacas] = useState();
  // const [Terminales, setTerminales] = useState();
  const [verTipo, setVerTipo] = useState(0);
  const [verTabla, setVerTabla] = useState(0);
  const [errorMessageA, setErrorMessageA] = useState('');
  const [errorMessageB, setErrorMessageB] = useState('');
  const [datosCorrectosA, setdatosCorrectosA] = useState(false);
  const [datosCorrectosB, setdatosCorrectosB] = useState(false);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState('');
  const [texto, setlabel] = useState('');
  const [fecha, setFecha] = useState('');
  const [estados, setEstado] = useState()



  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const opcion = (val) => {
    setVerTipo(parseInt(val.value));
  }
  const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
  const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
  const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
  const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
  const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
  const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
  const regExpBici = /^BICI[0-9]{3}$/;

  const verificarPlaca = (placa) => {
    console.log(placa);
    if (
      regExpCarro.test(placa) ||
      regExpCarroR.test(placa) ||
      regExpCarroA.test(placa) ||
      regExpCarroV.test(placa) ||
      regExpMoto.test(placa) ||
      regExpMotoAntigua.test(placa) ||
      regExpBici.test(placa)
    ) {
      setPlaca(true);
    } else {
      setPlaca(false);
    }
  };

  const onSubmit = async (data) => {
    // setPlaca(0)
    console.log(data.placa);
    console.log(data.terminal);
    console.log(data.terminales);
    const parametros = {
      cod_park: data.terminales.value,
    }
    console.log(parametros);
    console.log('parametros');
    setLoading(true)
    try {
      // const filteredTerminales = Terminales.filter((terminal) => terminal.cod_park === parametros.cod_park);
      //     console.log(filteredTerminales[0].nombre_park);
      //     setPark(filteredTerminales[0].nombre_park)
      const resultado = await axios.get(`${URL_EMPLOYEE}/desenganchadas/consultarPlacasEnganchadas/${parametros.cod_park}/""`)
      setLoading(false)
      setDatos(false)
      resul(resultado)

      function resul(resultado) {
        console.log(resultado.data["status"]);
        if (resultado.data["status"]) {
          setVerTabla(1);
          setVerTipo(0)
          const objeto = resultado.data["data"]
          
          for (let i = 0; i < objeto.length; i++) {
            const fechaHora = objeto[i].fecha_hora;
            const fecha = fechaHora.split("T")[0];
            const hora = fechaHora.split("T")[1].replace(".000Z", "");

            objeto[i].fecha_hora = fecha + " " + hora;

          }
          // const objeto1 = objeto.sort(function(a, b) {
          //     const dateA = new Date(a.fecha_hora);
          //     const dateB = new Date(b.fecha_hora);
          //     return dateB - dateA;
          //   });
          const objeto1 = objeto.sort(function (a, b) {
            const dateA = new Date(a.fecha_hora);
            const dateB = new Date(b.fecha_hora);
            return dateA - dateB;
          });
          setData(objeto1)
          setErrorMessageA('');
          setErrorMessageB('');
        } else {
          toast.error('No se encontro el parquedaero ');
          setVerTipo(0)

        }
      }
      reset({
        cod_park: '',
      });
    } catch (error) {
      toast.error('Algo salio mal..');
      setLoadingData(false);
    }
  }
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 800);

  }, []);
  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <Container >
        <form onSubmit={handleSubmit(onSubmit)}>
          {Terminales ? (
            <Row className="contenedorT-Filtrado">
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className='texto-label'>Parqueadero</Form.Label>
                  <Controller
                    name="terminales"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'El campo es obligatorio',
                      }
                    }}
                    // rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Select
                        onChange={(data) => {
                          onChange(data);
                        }}
                        value={value}
                        // placeholder="Elige una opción"
                        options={Terminales}
                      />

                    )}
                  />
                  {errors.terminales && (
                    <Form.Text id="passwordHelpBlock" className="error">
                      El campo es obligatorio
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

            </Row>
          ) : null}
          <Row className="justify-content-end mbottom-20">
            <Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
            >
              {loadingData ? (
                <Spinner animation="border" size="sm" />
              ) : (
                'Consultar Placas'
              )}
            </Button>
          </Row>
        </form>
      </Container>
      {verTabla === 1 ? (
        <>
          <Row className="mtop-40">
            {park !== '' ? (
              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                <p className='texto-subtitulo'>Parqueadero:<span className='span'> {park}</span> </p>
              </Col>
            ) : null}
          </Row>


          <TableComponent data={data} datos={datos} />
          {/* <TablePComponent  data={data}/> */}


        </>
      ) :
        null}
      {/* {verTabla === 2 ? (
                <>
                    <FormularComponen placas={placas} TerminalesB={Terminales}></FormularComponen>

                </>
            ) :
                null} */}

    </>
  );

};
export default BuscadorComponen;